import { AnimatedRangeProfitRoot } from "styles/styles";

const AnimatedRangeProfit = () => {
  return (
    <AnimatedRangeProfitRoot>
      <div className="range">
        <div className="range-layer-1 bg-green"></div>
        <div className="range-layer-2 bg-gray-30"></div>
      </div>

      <div className="flex-row">
        <div className="flex-col flex-col-left">
          <div className="rec bg-red"></div>
          <div className="flex-col__secondary-text">Without Us</div>
          <div className="flex-col__main-text text-red">
            $1,500/<span>NET</span>
          </div>
        </div>
        <div className="flex-col flex-col-centered">
          <div className="rec bg-green"></div>
          <div className="flex-col__secondary-text font-600">
            With Trucking42
          </div>
          <div className="flex-col__main-text">
            $5,500/<span>NET</span>
          </div>
        </div>
        <div className="flex-col flex-col-right">
          <div className="rec bg-green"></div>
          <div className="flex-col__secondary-text">And More</div>
          <div className="flex-col__main-text text-green">
            +$7,500/<span>NET</span>
          </div>
        </div>
      </div>
    </AnimatedRangeProfitRoot>
  );
};

export default AnimatedRangeProfit;
